// Meal tags for preferences - alphabetically sorted
export const mealTags = [
  { name: "Asian", icon: "🥢" },
  { name: "BBQ", icon: "🍖" },
  { name: "Chinese", icon: "🥡" },
  { name: "Comfort Food", icon: "🍲" },
  { name: "Good Leftovers", icon: "📦" },
  { name: "Greek", icon: "🏛️" },
  { name: "Healthy", icon: "🥗" },
  { name: "Indian", icon: "🍛" },
  { name: "Italian", icon: "🍝" },
  { name: "Kid-Friendly", icon: "👶" },
  { name: "Mediterranean", icon: "🌿" },
  { name: "Mexican", icon: "🌮" },
  { name: "Pizza", icon: "🍕" },
  { name: "Seafood", icon: "🦐" },
  { name: "Small Business", icon: "🏪" },
  { name: "Soup", icon: "🍜" },
  { name: "Southern", icon: "🍗" },
  { name: "Spicy", icon: "🌶️" },
  { name: "Thai", icon: "🥥" },
  { name: 'Fast Food', icon: '🍔'}
];

// Sample restaurant data - alphabetically sorted (keeping for backward compatibility)
export const popularRestaurantsList = [
  "Applebee's",
  "Burger King",
  "Cheesecake Factory", 
  "Chili's", 
  "Chipotle",
  "Domino's Pizza", 
  "Five Guys",
  "In-N-Out Burger",
  "Magiano's", 
  "Olive Garden", 
  "Outback Steakhouse", 
  "P.F. Chang's", 
  "Panda Express",
  "Panera Bread", 
  "Pizza Hut", 
  "Red Lobster",
  "Shake Shack", 
  "Chick-fil-A", 
  "Popeyes", 
  "Portillo's",
];

// Sample homemade meal suggestions - alphabetically sorted (keeping for backward compatibility)
export const homemadeMealSuggestions = [
    "Baked Ziti", 
    "Beef Stew",
    "Chicken Casserole", 
    "Chicken Parmesan", 
    "Chili Mac",
    "Fried Rice",
    "Chicken Noodle Soup",
    "Homemade Burgers",
    "Homemade Pizza", 
    "Lasagna", 
    "Mac & Cheese",
    "Meatloaf", 
    "Pot Roast", 
    "Hot Dogs / Sausages",
    "Roast Chicken", 
    "Shepherd's Pie",
    "Sloppy Joes",
    "Spaghetti & Meatballs",
    "Stuffed Peppers",
    "Tacos"
];

// US States for dropdown
export const usStates = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", 
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", 
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", 
  "VA", "WA", "WV", "WI", "WY"
];